import React, { useEffect } from "react";
import LikeProduitPage from "../components/likeProduit/LikeProduitPage";
import HomeHeader from "@/components/homePage/HomeHeader";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
export default function LikeProduit({ paniernbr, acces }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <LikeProduitPage />
    </>
  );
}
